import React from 'react';
import PropTypes from 'prop-types';
import { ReactSVG } from 'react-svg';
import BeatLoader from 'react-spinners/BeatLoader';
import { AnimatePresence, motion } from 'framer-motion';

import colors from 'styles/theme/colors';
import { LoaderWrapper, StyledButton } from './styles';

const LOADER_SIZE = 8;
const LOADER_MARGIN = 2;

const Loader = () => (
  <LoaderWrapper
    initial={{ opacity: 0, y: 5 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -10 }}
  >
    <BeatLoader
      loading
      color={colors.backgroundColorWhite}
      size={LOADER_SIZE}
      margin={LOADER_MARGIN}
    />
  </LoaderWrapper>
);

const Button = ({
  children, onClick, disabled, variant, className,
  icon, loading, loadingLabel,
}) => (
  <AnimatePresence exitBeforeEnter>
    <StyledButton
      type="button"
      onClick={onClick}
      disabled={disabled || loading}
      variant={variant}
      className={className}
      isLoading={loading}
    >
      {icon && <ReactSVG src={icon} />}
      <motion.span
        transition={{ duration: 0.2 }}
        layout={!!loadingLabel}
      >
        {loading ? loadingLabel : children}
      </motion.span>
      {loading && <Loader />}
    </StyledButton>
  </AnimatePresence>
);

Button.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf(['primary', 'secondary', 'link']),
  className: PropTypes.string,
  icon: PropTypes.node,
  loading: PropTypes.bool,
  loadingLabel: PropTypes.string,
};

Button.defaultProps = {
  disabled: false,
  variant: 'primary',
  className: null,
  icon: null,
  loading: false,
  loadingLabel: null,
};

export default Button;
